<template>
  <v-container fluid class="payroll-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Payroll</v-stepper-step>
              <v-divider></v-divider>
            </v-stepper-header>
          </v-card>
          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="7">
                      <p class="text-h5">Create New Payroll</p>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="4">
                      <v-form>
                        <v-menu
                          ref="menu_payrolldate"
                          v-model="menu_payrolldate"
                          :close-on-content-click="false"
                          :return-value.sync="payroll.payrolldate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              class="mb-4"
                              outlined
                              dense
                              persistent-hint
                              v-model="payroll.payrolldate"
                              placeholder="Payroll Date"
                              v-bind="attrs"
                              v-bind:value="payroll.payrolldate"
                              v-bind:error="errorindex == 0"
                              v-on="on"
                              single-line hint="Please enter the payroll date"
                              >
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="payroll.payrolldate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_payrolldate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_payrolldate.save(payroll.payrolldate);calculateDate()"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-menu
                          ref="menu_payrollstartdate"
                          v-model="menu_payrollstartdate"
                          :close-on-content-click="false"
                          :return-value.sync="payroll.payrollstartdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              class="mb-4"
                              outlined
                              dense
                              persistent-hint
                              v-model="payroll.payrollstartdate"
                              placeholder="Start Date"
                              v-bind="attrs"
                              v-bind:value="payroll.payrollstartdate"
                              v-bind:error="errorindex == 1"
                              v-on="on"
                              single-line hint="Enter start date"
                              >
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="payroll.payrollstartdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_payrollstartdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_payrollstartdate.save(payroll.payrollstartdate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-menu
                          ref="menu_payrollenddate"
                          v-model="menu_payrollenddate"
                          :close-on-content-click="false"
                          :return-value.sync="payroll.payrollenddate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              class="mb-4"
                              outlined
                              dense
                              persistent-hint
                              v-model="payroll.payrollenddate"
                              placeholder="End Date"
                              v-bind="attrs"
                              v-bind:value="payroll.payrollenddate"
                              v-bind:error="errorindex == 2"
                              v-on="on"
                              single-line hint="Enter end date"
                              >
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="payroll.payrollenddate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_payrollenddate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_payrollenddate.save(payroll.payrollenddate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-select
                        class="mb-4"
                        :items="['Singapore', 'Cambodia']"
                        v-model="payroll.template"
                        v-bind:error="errorindex == 3"
                        outlined
                        dense
                        placeholder="Payroll Template"
                        persistent-hint
                        single-line hint="Please choose the payroll template">
                      </v-select>
                      <v-text-field
                        v-show="payroll.template=='Cambodia'"
                        type="number"
                        class="mb-4"
                        v-model="payroll.currencyRate"
                        v-bind:error="errorindex == 4"
                        outlined
                        dense
                        placeholder="Currency Rate"
                        persistent-hint
                        single-line hint="Enter the currency rate">
                      </v-text-field>
                      <v-text-field
                        v-show="payroll.template=='Cambodia'"
                        type="number"
                        class="mb-4"
                        v-model="payroll.currencyRate2"
                        v-bind:error="errorindex == 5"
                        outlined
                        dense
                        placeholder="Currency Rate (optional)"
                        persistent-hint
                        single-line hint="Enter the optional currency rate">
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="7">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/payroll/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="createPayroll()">
                            Save
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      step: 1,
      payroll: {
        payrolldate: null,
        payrollstartdate: null,
        payrollenddate: null,
        currencyRate: null,
        currencyRate2: null,
      },
      valuetypes: ['Amount', 'Percentage'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
      menu_payrolldate: null,
      menu_payrollenddate: null,
      menu_payrollstartdate: null,
      payrolldate: null,
      payrollstartdate: null,
      payrollenddate: null,
      currencyRate: null,
      currencyRate2: null,
    }
  },

  methods: {
    ...mapActions('Country', ['getCountriesRequest']),
    ...mapActions('Payroll', ['insertPayroll','getPayrollsRequest']),
    ...mapActions('SystemSetting', ["getSetting", "getSystemSettingsRequest"]),
    checkError(){
      if(!this.payroll.payrolldate){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.payroll.payrollstartdate){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.payroll.payrollenddate){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      if(!this.payroll.template){
        this.haserrors = true;
        this.errorindex = 3;
        return false;
      }
      if(!this.payroll.currencyRate){
        this.haserrors = true;
        this.errorindex = 4;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    calculateDate(){
      let today = new Date(this.payroll.payrolldate);
      var last = new Date(today.getFullYear(), today.getMonth()+1, 0);
      let month = today.getMonth()<9 ? "0" + (today.getMonth()+1).toString() : (today.getMonth()+1).toString();
      this.payroll.payrollstartdate = today.getFullYear() + "-" + month + "-" + "1";
      this.payroll.payrollenddate = today.getFullYear() + "-" + month + "-" + last.getDate();
    },
    async createPayroll() {
      if(!this.checkError()) return;
      await this.insertPayroll(this.payroll);
      router.push('/payroll/list');
    },
  },
  computed: {
    ...mapState('Country', ['countries']),
    ...mapState('Payroll', ['isReceiving']),
    ...mapState('SystemSetting', ['settings']),
  },
  async created() {
    var today = new Date();
    var last = new Date(today.getFullYear(), today.getMonth()+1, 0);
    let month = today.getMonth()<9 ? "0" + (today.getMonth()+1).toString() : (today.getMonth()+1).toString();
    this.payroll.payrolldate = today.getFullYear() + "-" + month + "-" + today.getDate();
    this.payroll.payrollstartdate = today.getFullYear() + "-" + month + "-" + "1";
    this.payroll.payrollenddate = today.getFullYear() + "-" + month + "-" + last.getDate();
    if(this.countries.length==0) await this.getCountriesRequest();
    if(this.settings.length==0) await this.getSystemSettingsRequest();

    this.currencyRate = await this.getSetting({code: 'CurrencySettings', name: 'DefaultCurrencyRate'}, );
    this.payroll.currencyRate = parseFloat(this.currencyRate);
  },
}
</script>

<style src="./Add.scss" lang="scss"></style>
